import isStandardQuestion from './isStandardQuestion'

// AI-CONTEXT: See docs/features/msi-effect-questionnaire-attach.md
// De prullenbak in de vragenlijst-bouwer betekent twee dingen. Een eigen vraag
// hoort bij de vragenlijst en wordt soft-deleted (ADR-008). Een meetstandaardvraag
// hoort bij het effect in de Theory of Change en heeft precies één veld; die wordt
// LOSGEKOPPELD (QuestionnaireID '' = nog in geen vragenlijst), anders is het effect
// daarna nooit meer aan een vragenlijst toe te voegen — de toevoegpagina slaat
// verwijderde velden over. Hellendoorn, 2026-09.

/**
 * @typedef {object} RemoveContext
 * @property {*} timestamp - Firestore-timestamp voor DeletedAt
 * @property {string} [userId] - ID van de ingelogde gebruiker voor DeletedBy
 */

/**
 * Geeft de update-payload om een veld uit een vragenlijst te halen.
 * @param {object} field - Een QuestionnaireFields-doc
 * @param {RemoveContext} ctx
 * @returns {object} Payload voor `.update()`
 */
const removeFieldFromQuestionnaire = (field, { timestamp, userId }) => (
    isStandardQuestion(field)
        ? { QuestionnaireID: '', SectionID: '' }
        : { Deleted: true, DeletedAt: timestamp, DeletedBy: userId || '' }
)

/**
 * @typedef {object} RemoveFieldCopy
 * @property {string} title - Kop van het bevestigingsvenster
 * @property {string} body - Uitleg wat er gebeurt
 * @property {string} confirmLabel - Tekst op de bevestigingsknop
 */

/**
 * Teksten voor het bevestigingsvenster bij de prullenbak — één klik was te
 * weinig: de lijst schuift op en de volgende prullenbak ligt onder de muis.
 * @param {object} field - Een QuestionnaireFields-doc
 * @returns {RemoveFieldCopy}
 */
const removeFieldCopy = (field) => (
    isStandardQuestion(field)
        ? {
            title: 'Vraag uit de vragenlijst halen',
            body: 'Deze meetstandaardvraag gaat uit de vragenlijst. Het effect blijft in je Theory of Change staan en je kunt de vraag later weer toevoegen, aan deze of aan een andere vragenlijst.',
            confirmLabel: 'Uit de vragenlijst halen',
        }
        : {
            title: 'Vraag verwijderen',
            body: `Weet je zeker dat je '${field?.Question || field?.Title || 'deze vraag'}' wilt verwijderen?`,
            confirmLabel: 'Verwijderen',
        }
)

export { removeFieldCopy }
export default removeFieldFromQuestionnaire
